var currency = {
  UPPER: 'GBP',
  LOWER: 'gbp'
};
export { currency as default };